import React, { useEffect, useMemo, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import Animated, { Easing, useAnimatedStyle, useSharedValue, withDelay, withTiming, } from 'react-native-reanimated';
const AnimatedRevealContainer = ({ children, duration = 1000, delay = 0, extraHeight = 0, startingHeight = 0, disableAnimate = false, }) => {
    const height = useSharedValue(startingHeight);
    const opacity = useSharedValue(0);
    const overflow = useSharedValue('visible');
    const [measured, setMeasured] = useState(false);
    const [targetHeight, setTargetHeight] = useState(startingHeight);
    const timingOptions = useMemo(() => ({
        duration,
        easing: Easing.bezier(0.28, 0.68, 0.25, 1),
    }), [duration]);
    useEffect(() => {
        if (measured && !disableAnimate) {
            overflow.set('hidden');
            height.value = withDelay(delay, withTiming(targetHeight, timingOptions));
            opacity.value = withDelay(delay, withTiming(1, timingOptions));
            overflow.set(withDelay((delay + timingOptions.duration) * 0.8, withTiming('visible', { duration: 0 })));
        }
    }, [
        height,
        opacity,
        measured,
        targetHeight,
        delay,
        duration,
        timingOptions,
        disableAnimate,
        overflow,
    ]);
    const animatedStyle = useAnimatedStyle(() => ({
        height: disableAnimate ? 'auto' : height.value,
        opacity: disableAnimate ? 1 : opacity.value,
        overflow: disableAnimate ? 'visible' : overflow.get(),
    }));
    return (<View>
      {measured || disableAnimate ? (<Animated.View style={animatedStyle}>{children}</Animated.View>) : (<View style={styles.measurer} onLayout={(e) => {
                setTargetHeight(e.nativeEvent.layout.height + extraHeight);
                setMeasured(true);
            }} pointerEvents="none">
          {children}
        </View>)}
    </View>);
};
const styles = StyleSheet.create({
    measurer: {
        position: 'absolute',
        opacity: 0,
        left: 0,
        right: 0,
    },
});
export default AnimatedRevealContainer;
